module.exports = __webpack_public_path__ + "static/media/nose.1a331d26.svg";